import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import * as DOMPurify from 'dompurify';
import { Seperator } from "./";
import {myGlobals} from '../../Utils';

class PaymentGroup extends React.Component {
  renderMethods = (methods) => {
    let arr = [];
    let row;
    let divideBy = myGlobals.currentTheme === "trifectaTheme.css" ? 5 : 2;
    for (let i = 0; i < methods.length; ++i) {
      if (i % divideBy === 0) {
        if (row !== undefined)
          arr.push(<Row className="margin-top evenly-space">{row}</Row>);
        row = [];
      }
      row.push(methods[i]);
    }

    arr.push(<Row className="margin-top evenly-space">{row}</Row>);
    return arr;
  };
  centerContainer = () => {
    if (this.props.centerContainer) return "centered-container2";
  };
  render() {
    const children = React.Children.toArray(this.props.children);
    return (
      <React.Fragment>
        <Seperator className={`row-${this.centerContainer()}`}  text={DOMPurify.sanitize(this.props.seperatorText)} />
        <Row className={`row-second-${this.centerContainer()}`}>
          <Col className="inherit">
            <Container className={this.centerContainer()}>
              {this.renderMethods(children)}
            </Container>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default PaymentGroup;
